module.exports = __webpack_public_path__ + "static/media/1.b6d53a6a.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/hair/1.png
// module id = 1250
// module chunks = 0